module.exports = __webpack_public_path__ + "static/img/Frame_4268@2x.1878c03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/serviceImg/service/Frame_4268@2x.png
// module id = u/Sc
// module chunks = 59